import apiFetch from '../apiFetch'

export default function (token, data) {
  return apiFetch({ endPoint: 'UnattendedProcess/SetEconomicPlanProcess', method: 'POST', body: data, token: token })
}
